(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 3.3,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 2.3, slidesToScroll: 1 } },
        //{ breakpoint: 1024, settings: { slidesToShow: , slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 1.8, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1.3, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.carousel-collection ul').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $(function() {    
    $('body').on('click','.footer-block.grid__item .footer-block__heading',function(){
      if (window.matchMedia("(max-width: 749px)").matches) {
        let parent = $(this).closest('.footer-block.grid__item');
        
        if(parent.hasClass('active'))
          parent.removeClass('active');
        else
          parent.addClass('active');
      }
    });

    $(window).on('resize', function() {
      if (window.matchMedia("(min-width: 750px)").matches) {
        $('.footer-block.grid__item .footer-block__heading').removeClass('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furniture_collection_slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let leftSliderConfig = {
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      swipe: false,
      swipeToSlide: false,
      touchMove: false
    };
    let rightTopSliderConfig = {
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      swipe: false,
      swipeToSlide: false,
      touchMove: false
    };
    let rightBottomSliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      focusOnSelect: true,
      swipe: false,
      swipeToSlide: false,
      touchMove: false,
      asNavFor: '.furniture ul.right.top, .furniture ul.left'
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.furniture ul.left').not('.slick-initialized').slick(leftSliderConfig).slick('resize'); 
        jQuery('.furniture ul.right.top').not('.slick-initialized').slick(rightTopSliderConfig).slick('resize');
        jQuery('.furniture ul.right.bottom').not('.slick-initialized').slick(rightBottomSliderConfig).slick('resize'); 

        let mainSlider = jQuery('.furniture ul.right.bottom');
        mainSlider.append('<div class="slick-count"><span class="current">1</span><span class="sum"></span></div>');
        let countCurr = mainSlider.find('.slick-count').children('.current');
        let countSum = mainSlider.find('.slick-count').children('.sum');
        countSum.text("/" + mainSlider.find('.slick-slide:not(.slick-cloned)').length);

        mainSlider.on('init reInit afterChange', function (event, slick, currentSlide) {
          //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
          var i = (currentSlide ? currentSlide : 0) + 1;
          //counter.text(i + '/' + slick.slideCount);
          
          countCurr.text(i);
        });
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["get_inspired"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 2.5, slidesToScroll: 1 } },
        //{ breakpoint: 1024, settings: { slidesToShow: , slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 1.8, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.get-inspired ul').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  $('body').on('click','.header__icons .site-switcher .current',function() {
    $('.header__icons .site-switcher').toggleClass('active');
  });
  $('body').on('click','#menu-drawer .site-switcher .current',function() {
    $('#menu-drawer .site-switcher').toggleClass('active');
  });
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-slider-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() { 
    let sliderConfig = {
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        //{ breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        //{ breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1.2, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.lookbooks').not('.slick-initialized').slick(sliderConfig).slick('resize');
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  $(function() {
    if($('cart-items').hasClass('is-empty')) {
      $('#MainContent').addClass('empty-cart');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false, 
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 4.75,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 4.25, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 3.75, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 3.25, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 2.25, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.child-wrapper .child-levels').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function setCookie(name, value) {
      document.cookie = name + '=' + value + ';path=/';
    }

    // Function to get cookie value by name
    function getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim().split('=');
        if (cookie[0] === name) {
          return cookie[1];
        }
      }
      return null;
    }
    const productGrid = $('#product-grid');
    const columnModeOptions = $('.column-mode .option');

    function applyColumnModeFromCookie() {
      const columnModeCookie = getCookie('grid_column_mode');
      
      if (columnModeCookie) {
        columnModeOptions.removeClass('active');
        productGrid.removeClass('one-column two-column');

        $('.column-mode .option.'+columnModeCookie).addClass('active');
        productGrid.addClass(columnModeCookie);
      } 
    }

    applyColumnModeFromCookie();
    
    $('body').on('click','.column-mode .option:not(.active)', function() {
      if(window.matchMedia('(max-width: 749px)')) {
        $('.column-mode .option.active').removeClass('active');
        $(this).addClass('active');
        productGrid.removeClass('one-column, two-column');
        let applyColumnMode = '';
        
        if($(this).attr('id')=='oneCol')
          applyColumnMode = 'one-column';
        else
          applyColumnMode = 'two-column';
        
        productGrid.addClass(applyColumnMode);
        setCookie('grid_column_mode', applyColumnMode);
      }
      else {
        productGrid.removeClass('one-column, two-column');
        const now = new Date();
        document.cookie = `grid_column_mode=;expires=${now.toUTCString()};path=/`;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq"]) return;
  try {
    
  $(function() {
    $('body').on('click', '.section-nav a', function(e) {
      e.preventDefault();
      let target = $(this).attr('href');
      $('html, body').animate({
        scrollTop: $(target).position().top
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-store-location"]) return;
  try {
    
  $(function() {
    $('body').on('click','.stores-tab li:not(.active) a', function(e) {
      e.preventDefault();
      $('.stores-tab li.active').removeClass('active');
      $(this).closest('li').addClass('active');
      $('.stores.active').removeClass('active');
      $($(this).data('target')).addClass('active');
      $($(this).data('target')).find('.store-nav li:first-child a').trigger('click');
    });
    $('body').on('click','.store-nav li:not(.active) a', function(e) {
      e.preventDefault();
      $('.store-nav li.active').removeClass('active');
      $(this).closest('li').addClass('active');
      $('.store-wrapper.active').removeClass('active');
      $($(this).data('target')).addClass('active');
    });
    $('body').on('click','.store-nav li', function(e) {
      e.preventDefault();
      const nav = $(this).closest('.store-nav');
      
      if (window.matchMedia("(max-width: 749px)").matches) {
        if(nav.hasClass('nav-open'))
          nav.removeClass('nav-open');
        else
          nav.addClass('nav-open');
      }
    });
    $('body').on('click','.store-nav #nav-arrow', function(e) {
      $('.store-nav li').trigger('click');
    });
    $(window).on("resize", function() {
      if (window.matchMedia("(min-width: 750px)").matches) {
        $('.store-nav.nav-open').removeClass('nav-open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-list-items"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('body').on('click','.portfolio.tabs a',function(e){
      e.preventDefault();
      let targetClass = $(this).data('class');
      $('.portfolio.tabs li.active').removeClass('active');
      $(this).parent('li').addClass('active');
      if(targetClass=="all") {
        $('.portfolio-list li').each(function() {
          $(this).show();
        });
        $('.portfolio-list li.empty').hide();
      }
      else {
        if($('.portfolio-list li.'+targetClass).length == 0) {
          $('.portfolio-list li').hide();
          $('.portfolio-list:first li.empty').show();
        }
        else {
          $('.portfolio-list li:not(.'+targetClass+')').hide();
          $('.portfolio-list li.'+targetClass).show();
        }
      }
    });
  
    $(window).on('load', function() {
      let currentUrl = window.location.search;
      let urlParams = new URLSearchParams(window.location.search);
      let paramType = urlParams.get('type');
      let count = 1;
      $('.portfolio-list').each(function() {
        $(this).addClass('list'+count++);
      });
      $("ul.portfolio-list:not(.list1) li").appendTo("ul.portfolio-list.list1");
      $('.portfolio-list').each(function() {
        if($(this).children('li').length==0)
          $(this).remove();
      });

      $('.portfolio.tabs li a').each(function() {
        if($(this).data('class') == paramType) {
          $(this).click();
        } 
      });
    })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description-tab"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('body').on('click','.prod-desc .row H4',function(){
      if (window.matchMedia("(max-width: 749px)").matches) {
        if($(this).closest('.row').hasClass('active'))
          $(this).closest('.row').removeClass('active');
        else
          $(this).closest('.row').addClass('active');
      }
    });

    $(window).on('resize', function() {
      if (window.matchMedia("(min-width: 750px)").matches) {
        $('.prod-desc .row.active').removeClass('active');
      }
    });

    $('body').on('click','.prod-desc .desc-tabs a', function(e) {
      e.preventDefault();
      let target = $(this).data('target-id');
      $('html, body').animate({ scrollTop: $(target).position().top }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-lookbook"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 3, 
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        //{ breakpoint: 1024, settings: { slidesToShow: , slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.related-lookbook ul').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        //{ breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.related-products ul.product-grid').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 750);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-stories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 3, 
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        //{ breakpoint: 1024, settings: { slidesToShow: , slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.related-stories ul').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-portfolio-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let sliderConfig = {
      arrows: true,
      autoplay: false,
      autoplaySpeed: 4000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      slidesToShow: 3, 
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        //{ breakpoint: 1024, settings: { slidesToShow: , slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.portfolio-case ul').not('.slick-initialized').slick(sliderConfig).slick('resize'); 
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single_lookbook"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    const popup2c = $('#lb_single_popup');
    
    $('body').on('click','.lb-single .lb_dot',function() {
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');
      let targetId = $(this).data('target-id');
      
      popup2c.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2c.find('.lb_dot_item').each(function() {
        if($(this).attr('id')!=targetId)
          $(this).hide();
      });
      popup2c.addClass('active');
    });
    
    $('body').on('click','.lb-single .button.view-all',function(e) {
      e.preventDefault();
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');

      popup2c.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2c.find('.lb_dot_item').each(function() {
        $(this).show();
      });
      popup2c.addClass('active full');
    });
    
    $('body').on('click','#lb_single_popup .dim, #lb_single_popup .action-close', function() {
      $('html').removeClass('freeze');
      popup2c.removeClass('active full');
      popup2c.find('.pop_block').hide();
      popup2c.find('.lb_dot_item').each(function() {
        $(this).show();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-overlap-herobanner"] && !Shopify.designMode) return;
  try {
    
$(function() {
  $(window).scroll(function() { 
    if (!($('.herobanner').data('apply-title-animation') === true)) {
      const target = $('#hero-title');
      const canvasAspect = $(window).height() / $(window).width();
      let scrollTop = $(this).scrollTop();
      let heroHeaderAdjust = $(window).height()/2;

      if(window.matchMedia("(max-width: 749px)").matches) {
        heroHeaderAdjust = 196;
        let targetLeft = (scrollTop - heroHeaderAdjust)*-1;
      }
      else {
        let targetLeft = (scrollTop - heroHeaderAdjust)*canvasAspect*-1;
      }

      if(scrollTop > heroHeaderAdjust)
        target.css('margin-left', targetLeft)
      else
        target.css('margin-left', 0)
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trend_lookbook_and_productlist"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    const popup2cp = $('#lb_twocol-p_popup');
    
    $('body').on('click','.lb-twocol-p .lb_dot',function() {
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');
      let targetId = $(this).data('target-id');
      
      popup2cp.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2cp.find('.lb_dot_item').each(function() {
        if($(this).attr('id')!=targetId)
          $(this).hide();
      });
      popup2cp.addClass('active');
    });
    
    $('body').on('click','.lb-twocol-p .button.view-all',function(e) {
      e.preventDefault();
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');

      popup2cp.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2cp.find('.lb_dot_item').each(function() {
        $(this).show();
      });
      popup2cp.addClass('active full');
    });
    
    $('body').on('click','#lb_twocol-p_popup .dim, #lb_twocol-p_popup .action-close', function() {
      $('html').removeClass('freeze');
      popup2cp.removeClass('active full');
      popup2cp.find('.pop_block').hide();
      popup2cp.find('.lb_dot_item').each(function() {
        $(this).show();
      });
    });
  });

  $(window).on({
    scroll: function() {
      const lb2colprodSection = $('.lb-twocol-p');
      const lb2colprodMain = $('.lb-twocol-p .main');
      let entrylb2colprod = lb2colprodSection.position().top;
      let exitlb2colprod = lb2colprodSection.position().top + lb2colprodSection.height(); 
      
      if (window.matchMedia("(min-width: 750px)").matches) {
        if($(window).scrollTop() > entrylb2colprod && $(window).scrollTop() < exitlb2colprod)
          lb2colprodMain.addClass('sticky');
        else
          lb2colprodMain.removeClass('sticky');
      }
      else
        lb2colprodMain.removeClass('sticky');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trend_main_lookbook"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    const popup = $('#lb_popup');
    
    $('body').on('click','.lb-main .lb_dot',function() {
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');
      let targetId = $(this).data('target-id');
      
      popup.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup.find('.lb_dot_item').each(function() {
        if($(this).attr('id')!=targetId)
          $(this).hide();
      });
      popup.addClass('active');
    });
    
    $('body').on('click','.lb-main .button.view-all',function(e) {
      e.preventDefault();
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');

      popup.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup.find('.lb_dot_item').each(function() {
        $(this).show();
      });
      popup.addClass('active full');
    });
    
    $('body').on('click','#lb_popup .dim, #lb_popup .action-close', function() {
      $('html').removeClass('freeze');
      popup.removeClass('active full');
      popup.find('.pop_block').hide();
      popup.find('.lb_dot_item').each(function() {
        $(this).show();
      });
    });
  });
  
  $(window).on({
    scroll: function() {
      const lbSection = $('.lb-main');
      const lbMain = $('.lb-main .main');
      let entrylb = lbSection.position().top;
      let exitlb = lbSection.position().top + lbSection.height(); 
      
      if (window.matchMedia("(min-width: 750px)").matches) {
        if($(window).scrollTop() > entrylb && $(window).scrollTop() < exitlb)
          lbMain.addClass('sticky');
        else
          lbMain.removeClass('sticky');
      }
      else
        lbMain.removeClass('sticky');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trend_mood_collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() { 
    let sliderConfig = {
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3000,
      cssEase: 'linear',
      dots: false,
      infinite: false,
      vertical: false,
      speed: 1000,
      centerMode: false,
      slidesToShow: 2.7,
      slidesToScroll: 1,
      responsive: [
        //{ breakpoint: 1280, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 1024, settings: { slidesToShow: 2.3, slidesToScroll: 1 } },
        { breakpoint: 750, settings: { slidesToShow: 1, slidesToScroll: 1 } }//,
        //{ breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    };
    jQuery(function() {
      setTimeout(function(){
        jQuery('.mood_slides').not('.slick-initialized').slick(sliderConfig).slick('resize');
      }, 500);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trend_two_column_lookbook"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    const popup2c = $('#lb_twocol_popup');
    
    $('body').on('click','.lb-twocol .lb_dot',function() {
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');
      let targetId = $(this).data('target-id');
      
      popup2c.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2c.find('.lb_dot_item').each(function() {
        if($(this).attr('id')!=targetId)
          $(this).hide();
      });
      popup2c.addClass('active');
    });
    
    $('body').on('click','.lb-twocol .button.view-all',function(e) {
      e.preventDefault();
      $('html').addClass('freeze');
      let blockId = $(this).closest('.lb_block').data('target-block');

      popup2c.find('.pop_block').each(function() {
        if($(this).attr('id') == blockId)
          $(this).show();
        else
          $(this).hide();
      });
      popup2c.find('.lb_dot_item').each(function() {
        $(this).show();
      });
      popup2c.addClass('active full');
    });
    
    $('body').on('click','#lb_twocol_popup .dim, #lb_twocol_popup .action-close', function() {
      $('html').removeClass('freeze');
      popup2c.removeClass('active full');
      popup2c.find('.pop_block').hide();
      popup2c.find('.lb_dot_item').each(function() {
        $(this).show();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trend_video_and_products"] && !Shopify.designMode) return;
  try {
    
  $(window).on({
    load: function() {},
    scroll: function() {
      const trendVideoSection = $('.video-section.trend');
      const trendVideoBox = $('.video-section.trend .video-wrapper');
      let entryTrendVideo = trendVideoSection.position().top;
      let exitTrendVideo = trendVideoSection.position().top + trendVideoSection.height(); 
      
      if (window.matchMedia("(min-width: 750px)").matches) {
        if($(window).scrollTop() > entryTrendVideo && $(window).scrollTop() < exitTrendVideo)
          trendVideoBox.addClass('sticky');
        else
          trendVideoBox.removeClass('sticky');
      }
      else
        trendVideoBox.removeClass('sticky');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tribe_product_tabs"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('body').on('click','.tribe-tabs .tabs-wrapper a', function() {
      $('.tabs-wrapper li.active').removeClass('active');
      $('.tribe-product-tabs .tab-wrapper.active').removeClass('active');
      $(this).parent('li').addClass('active');
      let target = $($(this).data('target'));
      let targetTop = target.offset().top - 60;
      target.addClass('active');
      $('html, body').animate({
        scrollTop: targetTop 
      }, 500);
    });
  });
  $(window).on({
    scroll: function() {
      /* product collections main tabs */
      const collectionStickyTabs = $('.tribe-tabs .tabs-wrapper');
      const collectionTabs = $('.tribe-tabs .tribe-product-tabs');
      let entryProductTabs = collectionTabs.offset().top;
      let exitProductTabs = collectionTabs.offset().top + collectionTabs.height();

      if($(window).scrollTop() > entryProductTabs && $(window).scrollTop() < exitProductTabs)
        collectionStickyTabs.addClass('sticky');
      else
        collectionStickyTabs.removeClass('sticky');

      /* tabs sidebar collections */
      const tribeProdSection = $('.tribe-tabs');
      const tribeProdMain = $('.tribe-tabs .main');
      let entryTribeProd = tribeProdSection.offset().top;
      let exitTribeProd = entryTribeProd + tribeProdSection.height(); 

      if (window.matchMedia("(min-width: 750px)").matches) {
        if($(window).scrollTop() > entryTribeProd && $(window).scrollTop() < exitTribeProd)
          tribeProdMain.addClass('sticky');
        else
          tribeProdMain.removeClass('sticky');
      }
      else
        tribeProdMain.removeClass('sticky');

      /* when scrolling, highlight active tab */
      $('.tribe-product-tabs .tab-wrapper').each(function(index) {
        const tab = $(this);
        const tabTop = tab.offset().top;
        const tabEnd = tabTop + tab.height();
    
        if ($(window).scrollTop() > tabTop && $(window).scrollTop() < tabEnd) {
          $('.tabs-wrapper li.active').removeClass('active');
          $('.tabs-wrapper li:nth-of-type(' + (index + 1) + ')').addClass('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-we-do"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $('body').on('click','.whatwedo .services li H3', function() {
      if (window.matchMedia("(max-width: 749px)").matches) {
        let parent = $(this).parent('li');
        
        if(parent.hasClass('active'))
          parent.removeClass('active');
        else
          parent.addClass('active');
      }
    });

    $(window).on('resize', function() {
      if (window.matchMedia("(min-width: 750px)").matches) {
        $('.whatwedo .services li.active').removeClass('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
